module.exports = __webpack_public_path__ + "img/after-payment-header.1a03c221.svg";